import { graphql } from 'react-relay/hooks'
import { ConnectionHandler } from 'react-relay'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportArchiveMutation($input: ArchiveReportInput!) {
    archiveReport(input: $input) {
      report {
        id
        rowId
        company {
          id
        }
      }
    }
  }
`

const updater = (store, { archiveReport }) => {
  const company = store.get(archiveReport.report.company.id)

  // remove from the reports table when filtered to
  // not display deleted reports
  const connection = ConnectionHandler.getConnection(company, 'ReportsTable_reports', {
    orderBy: 'CREATED_AT_DESC',
    includeDeleted: 'NO',
  })

  if (connection) {
    ConnectionHandler.deleteNode(connection, archiveReport.report.id)
  }
}

export default function useReportArchive() {
  return useMutation(mutation, 'archiveReport', { updater })
}
